"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    title2ClassNames: function() {
        return title2ClassNames;
    },
    useTitle2Styles: function() {
        return useTitle2Styles;
    }
});
const _react = require("@griffel/react");
const title2ClassNames = {
    root: 'fui-Title2'
};
const useTitle2Styles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fojgt09",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "fcen8rp"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fojgt09{font-size:var(--fontSizeHero700);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".fcen8rp{line-height:var(--lineHeightHero700);}"
    ]
}); //# sourceMappingURL=useTitle2Styles.styles.js.map
